import React, { useState } from "react";
import { postNewsletter } from "../lib/api";
import { toast } from "sonner";

export const NewsletterForm = ({ variant = "default" }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await postNewsletter(email);
      toast.success(res.message || "Welcome to the Atelier.");
      setEmail("");
    } catch (err) {
      toast.error("Please enter a valid email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={onSubmit} className="w-full" data-testid="newsletter-form">
      <div className={`flex items-end gap-4 border-b ${variant === "dark" ? "border-[#f0e9e1]/40" : "border-[#1a1814]/30"} pb-2`}>
        <input
          type="email"
          required
          placeholder="Your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className={`flex-1 bg-transparent outline-none placeholder:opacity-50 ${variant === "dark" ? "text-[#f0e9e1]" : "text-[#1a1814]"}`}
          data-testid="newsletter-email-input"
        />
        <button
          type="submit"
          disabled={loading}
          className={`micro-label ${variant === "dark" ? "text-[#f0e9e1]" : "text-[#1a1814]"} hover:opacity-60 disabled:opacity-40`}
          data-testid="newsletter-submit-btn"
        >
          {loading ? "Sending" : "Subscribe"}
        </button>
      </div>
    </form>
  );
};
